var axios;
var Swiper;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            this.hangWebsiteSubmitForms = function () {
                var elements = document.querySelectorAll('[data-wssubmitform]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    hangAsyncSubmitToForm(el);
                }
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.galerySwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-galery-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new Swiper(el, {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        centeredSlides: true,
                        loop: true,
                        breakpoints: {
                            768: {
                                slidesPerView: 1.8,
                            }
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'custom',
                            renderCustom: function (swiper, current, total) {
                                var text = "";
                                for (var i_1 = 1; i_1 <= total; i_1++) {
                                    if (i_1 == 1) {
                                        text += "<span class='numbers'>0" + current + "</span>";
                                    }
                                    var active = (current == i_1) ? "active" : "";
                                    text += "<span class='custom-pag " + active + "' ></span>";
                                    if (i_1 == total) {
                                        text += "<span class='numbers'>0" + total + "</span>";
                                    }
                                }
                                return text;
                            }
                        },
                    });
                }
            };
            this.openMobileMenu = function () {
                var mobileMenu = document.querySelectorAll('.navbar-toggler')[0];
                mobileMenu.addEventListener('click', function () {
                    document.getElementsByTagName('body')[0].classList.remove('overflow');
                    if (!mobileMenu.classList.contains('collapsed')) {
                        document.getElementsByTagName('body')[0].classList.add('overflow');
                    }
                });
            };
            this.closeMobileMenu = function () {
                var mobileMenu = document.querySelectorAll('.mobile-menu-div')[0];
                var mobileNav = document.querySelectorAll('.navbar-toggler')[0];
                mobileMenu.addEventListener('click', function (e) {
                    if (e.target == mobileMenu) {
                        document.getElementsByTagName('body')[0].classList.remove('overflow');
                        mobileNav.classList.add('collapsed');
                        mobileMenu.classList.remove('show');
                    }
                });
            };
            this.servicesImageChange = function () {
                var divs = document.querySelectorAll(".checking-div");
                if (divs.length > 0) {
                    document.addEventListener('scroll', function () {
                        var BreakException = {};
                        var windowHeight = window.innerHeight / 2;
                        var dataTarget = "";
                        try {
                            divs.forEach(function (x) {
                                if (x.getBoundingClientRect().top < windowHeight && x.getBoundingClientRect().top > 60) {
                                    dataTarget = x.getAttribute('data-target');
                                    throw BreakException;
                                }
                                else if (x.getBoundingClientRect().top > 60) {
                                    dataTarget = divs[0].getAttribute('data-target');
                                }
                                else {
                                    dataTarget = x.getAttribute('data-target');
                                }
                            });
                        }
                        catch (e) {
                            if (e !== BreakException)
                                throw e;
                        }
                        var image = document.querySelectorAll(".changeable-image");
                        if (image.length > 0) {
                            image.forEach(function (x) {
                                x.classList.remove("show");
                            });
                        }
                        var target = document.getElementById(dataTarget);
                        target.classList.remove("hide");
                        target.classList.add("show");
                    });
                }
            };
            this.uploadFile = function () {
                var htmlUpload = $(".addCv");
                var input = $("#UploadedFile");
                if (htmlUpload.length > 0) {
                    htmlUpload.on("click", function () {
                        input.click();
                    });
                    input.change(function () {
                        $(".fileName").html(input.val().split('\\').pop());
                    });
                }
            };
            this.hangWebsiteSubmitForms();
            this.bindSwiperTmpFunc();
            this.galerySwiper();
            this.openMobileMenu();
            this.closeMobileMenu();
            this.uploadFile();
        }
        return Main;
    }());
    WebSite.Main = Main;
    function hangAsyncSubmitToForm(form) {
        form.addEventListener('submit', function (e) {
            var formEl = $(this);
            if (!formEl.valid())
                return;
            e.preventDefault();
            var allData = AllForWeb.getFormData(form);
            console.log(allData);
            $.ajax({
                type: "POST",
                dataType: "JSON",
                method: "POST",
                processData: false,
                contentType: false,
                data: allData
            }).then(function (result) {
                var formResponse = formEl.find(".form-respons");
                formResponse.show();
                var formStructure = formEl.find(".form-submit");
                formStructure.hide();
                setTimeout(function () {
                    formEl.find('input').not('[type=hidden], [type=checkbox]').val('');
                    var formResponse = formEl.find(".form-respons");
                    formResponse.hide();
                    var formStructure = formEl.find(".form-submit");
                    formStructure.show();
                }, 3000);
            }, function (err) {
            });
        });
    }
    WebSite.hangAsyncSubmitToForm = hangAsyncSubmitToForm;
})(WebSite || (WebSite = {}));
(function () {
    new WebSite.Main();
    new AllForWeb.FormSubmit();
    var domainName = window.location.hostname;
    var cookieMain = $('.cookie');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("analytic_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $('.cookie-dialog', cookieMain).fadeOut();
        window.location.reload();
    });
})();
//# sourceMappingURL=Main.js.map